import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function AdminIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("admin"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Admin" breadcrumb={["Admin", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="admin" />
      </div>
    </AppLayout>
  );
}
